import { useMemo } from 'react';
import { useSolanaLive } from './useSolanaLive';
import { getBuyQuote } from '../solana/quotes/buyQuote';
import { getSellQuote } from '../solana/quotes/sellQuote';
import { formatBuyQuoteValue, formatSellQuoteValue } from '../solana/utils/quoteFormat';

export function useTradeQuote(tradeSide, inputAmount) {
  const { globalConfig, currentGameState } = useSolanaLive();

  return useMemo(() => {
    const quoteLabel = tradeSide === 'sell' ? 'Estimated SOL Output' : 'Estimated Token Output';

    if (!inputAmount) {
      return {
        quoteValue: '',
        quoteLabel,
        quoteError: '',
        quoteRaw: null,
      };
    }

    if (!globalConfig || !currentGameState) {
      return {
        quoteValue: '',
        quoteLabel,
        quoteError: 'Waiting for live game data',
        quoteRaw: null,
      };
    }

    try {
      if (tradeSide === 'sell') {
        const quoteRaw = getSellQuote({
          globalConfig,
          currentGameState,
          tokenAmount: inputAmount,
        });

        return {
          quoteValue: formatSellQuoteValue(quoteRaw.netLamportsOut),
          quoteLabel,
          quoteError: '',
          quoteRaw,
        };
      }

      const quoteRaw = getBuyQuote({
        globalConfig,
        currentGameState,
        solAmount: inputAmount,
      });

      return {
        quoteValue: formatBuyQuoteValue(quoteRaw.tokenAmountOutAtomic),
        quoteLabel,
        quoteError: '',
        quoteRaw,
      };
    } catch (error) {
      return {
        quoteValue: '',
        quoteLabel,
        quoteError: error?.message || 'Unable to estimate quote.',
        quoteRaw: null,
      };
    }
  }, [currentGameState, globalConfig, inputAmount, tradeSide]);
}